import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogConnectNewSmartlockAccountComponent } from '@app/modules/apps/components/dialog-connect-new-smartlock-account/dialog-connect-new-smartlock-account.component';
import { DialogEditSmartlockComponent } from '@app/modules/apps/components/dialog-edit-smartlock/dialog-edit-smartlock.component';
import { DialogSmartlockConnectionFailureComponent } from '@app/modules/apps/components/dialog-smartlock-connection-failure/dialog-smartlock-connection-failure.component';
import { DialogSmartlockDeleteFutureCodesComponent } from '@app/modules/apps/components/dialog-smartlock-delete-future-codes/dialog-smartlock-delete-future-codes.component';
import { ChekinComponent } from '@app/modules/apps/pages/chekin/chekin.component';
import { CraftedstaysComponent } from '@app/modules/apps/pages/craftedstays/craftedstays.component';
import { CrewdogsComponent } from '@app/modules/apps/pages/crewdogs/crewdogs.component';
import { HostkitComponent } from '@app/modules/apps/pages/hostkit/hostkit.component';
import { HudsonCreativeStudioComponent } from '@app/modules/apps/pages/hudson-creative/hudson-creative.component';
import { LinkbaseComponent } from '@app/modules/apps/pages/linkbase/linkbase.component';
import { MinutComponent } from '@app/modules/apps/pages/minut/minut.component';
import { PricelabsComponent } from '@app/modules/apps/pages/pricelabs/pricelabs.component';
import { RankbreezeComponent } from '@app/modules/apps/pages/rankbreeze/rankbreeze.component';
import { SmartlockSuccessComponent } from '@app/modules/apps/pages/smartlock-success/smartlock-success.component';
import { SmartlockComponent } from '@app/modules/apps/pages/smartlock/smartlock.component';
import { StrlyComponent } from '@app/modules/apps/pages/strly/strly.component';
import { TechtapeComponent } from '@app/modules/apps/pages/techtape/techtape.component';
import { TheHostCoComponent } from '@app/modules/apps/pages/the-host-co/the-host-co.component';
import { WebreadyComponent } from '@app/modules/apps/pages/webready/webready.component';
import { WelcomescreenComponent } from '@app/modules/apps/pages/welcomescreen/welcomescreen.component';
import { SharedModule } from '@app/shared/shared.module';
import { AppsRoutingModule } from './apps-routing.module';
import { DialogDeleteAPIAccessTokenComponent } from './components/DialogDeleteAPIAccessToken/DialogDeleteAPIAccessToken.component';
import { DialogRevealApiAccessTokenComponent } from './components/DialogRevealApiAccessToken/DialogRevealApiAccessToken.component';
import { AppsDetailPageComponent } from './components/apps-detail-page/apps-detail-page.component';
import { AppsMobileBannerComponent } from './components/apps-mobile-banner/apps-mobile-banner.component';
import { AppsOverviewItemComponent } from './components/apps-overview-item/apps-overview-item.component';
import { AppsSubnavComponent } from './components/apps-subnav/apps-subnav.component';
import { DialogConfirmSendLegacyWebhooksComponent } from './components/dialog-confirm-send-legacy-webhooks/dialog-confirm-send-legacy-webhooks.component';
import { DialogCreateEmailRouteComponent } from './components/dialog-create-email-route/dialog-create-email-route.component';
import { DialogResyncLocksComponent } from './components/dialog-resync-locks/dialog-resync-locks.component';
import { DialogUpvoteComponent } from './components/dialog-upvote/dialog-upvote.component';
import { AlertifyComponent } from './pages/alertify/alertify.component';
import { ApiKeysComponent } from './pages/api-keys/api-keys.component';
import { AppsOverviewComponent } from './pages/apps-overview/apps-overview.component';
import { AutohostComponent } from './pages/autohost/autohost.component';
import { BetterStrComponent } from './pages/better-str/better-str.component';
import { BeyondComponent } from './pages/beyond/beyond.component';
import { BoostlyComponent } from './pages/boostly/boostly.component';
import { BreezewayComponent } from './pages/breezeway/breezeway.component';
import { ChargeautomationComponent } from './pages/chargeautomation/chargeautomation.component';
import { CleansterComponent } from './pages/cleanster/cleanster.component';
import { ClearingComponent } from './pages/clearing/clearing.component';
import { ConnectedAppsComponent } from './pages/connected-apps/connected-apps.component';
import { EmailRoutingComponent } from './pages/email-routing/email-routing.component';
import { HostbuddyAiComponent } from './pages/hostbuddy-ai/hostbuddy-ai.component';
import { HoufyComponent } from './pages/houfy/houfy.component';
import { JervisComponent } from './pages/jervis/jervis.component';
import { MailchimpComponent } from './pages/mailchimp/mailchimp.component';
import { OwnercenterComponent } from './pages/ownercenter/ownercenter.component';
import { QuickbooksComponent } from './pages/quickbooks/quickbooks.component';
import { ResortcleaningComponent } from './pages/resortcleaning/resortcleaning.component';
import { RueBaRueComponent } from './pages/rue-ba-rue/rue-ba-rue.component';
import { SafelyComponent } from './pages/safely/safely.component';
import { UnmatchedLockComponent } from './pages/smartlock/unmatched-lock/unmatched-lock.component';
import { StayfiComponent } from './pages/stayfi/stayfi.component';
import { SuiteopComponent } from './pages/suiteop/suiteop.component';
import { TidyComponent } from './pages/tidy/tidy.component';
import { TouchstayComponent } from './pages/touchstay/touchstay.component';
import { UpvoteComponent } from './pages/upvote/upvote.component';
import { VRPlatformComponent } from './pages/vr-platform/vr-platform.component';
import { WebhooksNextComponent } from './pages/webhooks/webhooks-next.component';
import { BuiltByLabelPipe } from './pipes/built-by-label.pipe';
import { CategoriesFilterLabelPipe } from './pipes/categories-filter-label.pipe';

@NgModule({
  declarations: [
    AppsOverviewComponent,
    MailchimpComponent,
    ApiKeysComponent,
    EmailRoutingComponent,
    DialogCreateEmailRouteComponent,
    UpvoteComponent,
    DialogUpvoteComponent,
    AutohostComponent,
    SmartlockComponent,
    DialogConnectNewSmartlockAccountComponent,
    SmartlockSuccessComponent,
    DialogEditSmartlockComponent,
    DialogSmartlockConnectionFailureComponent,
    DialogSmartlockDeleteFutureCodesComponent,
    AppsOverviewItemComponent,
    AppsMobileBannerComponent,
    DialogResyncLocksComponent,
    UnmatchedLockComponent,
    DialogRevealApiAccessTokenComponent,
    DialogDeleteAPIAccessTokenComponent,
    AppsSubnavComponent,
    BuiltByLabelPipe,
    CategoriesFilterLabelPipe,
    AppsDetailPageComponent,
    ResortcleaningComponent,
    CleansterComponent,
    OwnercenterComponent,
    JervisComponent,
    BreezewayComponent,
    SuiteopComponent,
    TheHostCoComponent,
    HostkitComponent,
    TechtapeComponent,
    CraftedstaysComponent,
    TouchstayComponent,
    WebhooksNextComponent,
    HudsonCreativeStudioComponent,
    DialogConfirmSendLegacyWebhooksComponent,
    PricelabsComponent,
    RankbreezeComponent,
    ChargeautomationComponent,
    ConnectedAppsComponent,
    HoufyComponent,
    StrlyComponent,
    LinkbaseComponent,
    WebreadyComponent,
    ChekinComponent,
    MinutComponent,
    VRPlatformComponent,
    TidyComponent,
    StayfiComponent,
    ClearingComponent,
    AlertifyComponent,
    BoostlyComponent,
    BeyondComponent,
    QuickbooksComponent,
    HostbuddyAiComponent,
    BetterStrComponent,
    SafelyComponent,
    CrewdogsComponent,
    RueBaRueComponent,
    WelcomescreenComponent,
  ],
  imports: [CommonModule, SharedModule, AppsRoutingModule],
})
export class AppsModule {}
